<template>
  <div class="rbc-cell-type-dropdown">
    <CellTypeMenu
      :label="buttonLabel"
      :options="menuOptions"
      @select="handleMenuSelect"
      @open="ensureRbcMode"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import {
  getDrawOptions,
  type CellTypeMenuOption,
} from "@/utils/constants/cellTypeMenuConfig";
import { useConfigStore } from "@/store";
import { useRBCSlideStore } from "@/store/modules/RBCregion";
import { useConstants } from "@/composables/useAppGlobals";
import CellTypeMenu from "./CellTypeMenu.vue";

const props = defineProps({
  label: {
    type: String,
    default: "Select RBC Type",
  },
});

const emit = defineEmits<{
  (e: "select", option: CellTypeMenuOption): void;
}>();

const configStore = useConfigStore();
const rbcSlideStore = useRBCSlideStore();
const $const = useConstants();

const menuOptions = computed<CellTypeMenuOption[]>(() =>
  getDrawOptions({ isRbc: true, consts: $const }),
);
const buttonLabel = ref(props.label);

function ensureRbcMode() {
  const slideInfo = {
    ...configStore.slideInfo,
    [$const.SLIDE_KEYS.IS_RBC]: true,
  } as Record<string, unknown>;
  configStore.setSlideInfo(slideInfo);
}

function handleMenuSelect(option: CellTypeMenuOption) {
  rbcSlideStore.setSelectedType(option);
  emit("select", option);
}

watch(
  () => rbcSlideStore.selectedLabel,
  (value) => {
    buttonLabel.value = value || props.label;
  },
  { immediate: true },
);

watch(
  () => props.label,
  (value) => {
    if (!rbcSlideStore.selectedLabel) {
      buttonLabel.value = value;
    }
  },
);

onMounted(() => {
  ensureRbcMode();
});
</script>

<style scoped>
.rbc-cell-type-dropdown {
  display: block;
  width: 100%;
}
</style>
